import { render } from "./StrokesTeamsOverview.vue?vue&type=template&id=50a7b338"
import script from "./StrokesTeamsOverview.vue?vue&type=script&lang=js"
export * from "./StrokesTeamsOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__